import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import { QueryProvider } from './app/providers/QueryProvider'
import { RootErrorBoundary } from './app/RootErrorBoundary'
import { ThemeProvider } from './app/providers/ThemeProvider'
import { ToastProvider } from './app/providers/ToastProvider'
// Self-hosted, so the console renders in the same faces on every machine —
// including the pinned browser-gate image, whose font set is otherwise what
// decides a baseline. Archivo's width axis carries the display hierarchy
// (tokens.css --stretch-*); only the Latin files are requested by a browser
// rendering English copy, the other subsets sit unrequested behind their
// unicode-range.
import '@fontsource-variable/archivo/wdth.css'
import '@fontsource/ibm-plex-mono/latin-400.css'
import '@fontsource/ibm-plex-mono/latin-500.css'
import './styles/globals.css'
// After globals.css on purpose: the motion and ambient layer adds to the
// shell's rules and must win ties against them.
import './styles/ambience.css'
import './styles/landing.css'

const root = document.getElementById('root')
if (!root) throw new Error('#root is missing from index.html')

createRoot(root).render(
  <StrictMode>
    <RootErrorBoundary>
      <ThemeProvider>
        <QueryProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </QueryProvider>
      </ThemeProvider>
    </RootErrorBoundary>
  </StrictMode>,
)
